import React from "react";
import { Tag, Popover, Button, List } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

const hostFromJdbcUrl = (jdbcUrl) => {
  if (!jdbcUrl) return "";
  const match = jdbcUrl.match(/\/\/([^:/]+)(:\d+)?\/([^?]+)/);
  return match ? match[1] : "";
};

const databaseFromJdbcUrl = (jdbcUrl) => {
  if (!jdbcUrl) return "";
  const match = jdbcUrl.match(/\/\/[^:/]+(:\d+)?\/([^?]+)/);
  return match ? match[2] : "";
};

const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleString("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "UTC",
  });
};

const getStatusColor = (status) => {
  switch ((status || "").toLowerCase()) {
    case "connected":
      return "success";
    case "disconnected":
      return "error";
    default:
      return "processing";
  }
};

export default function JeyedaDatasourcesTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
}) {
  const columns = [
    {
      title: "Connection Name",
      dataIndex: "label",
      key: "label",
      width: "15%",
      sorter: (a, b) => (a.label || "").localeCompare(b.label || ""),
    },
    {
      title: "Database Type",
      dataIndex: "dbFlavour",
      key: "dbFlavour",
      width: "15%",
      sorter: (a, b) => (a.dbFlavour || "").localeCompare(b.dbFlavour || ""),
    },
    {
      title: "Host",
      key: "host",
      width: "15%",
      render: (_, record) => hostFromJdbcUrl(record.jdbcUrl),
      sorter: (a, b) =>
        hostFromJdbcUrl(a.jdbcUrl).localeCompare(hostFromJdbcUrl(b.jdbcUrl)),
    },
    {
      title: "Database",
      key: "database",
      width: "15%",
      render: (_, record) => databaseFromJdbcUrl(record.jdbcUrl),
      sorter: (a, b) =>
        databaseFromJdbcUrl(a.jdbcUrl).localeCompare(
          databaseFromJdbcUrl(b.jdbcUrl),
        ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "15%",
      render: (val) => formatDate(val),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: "Owners",
      key: "owners",
      width: "15%",
      render: (_, record) => {
        const sharedToList = Array.isArray(record.sharedTo)
          ? record.sharedTo
          : [];
        const content = (
          <div style={{ minWidth: 200 }}>
            <div
              style={{
                fontWeight: "bold",
                color: "#0D2E4D",
                marginBottom: "8px",
                borderBottom: "2px solid #0D2E4D",
                paddingBottom: "8px",
              }}
            >
              Shared With
            </div>
            <List
              size="small"
              dataSource={sharedToList}
              renderItem={(u) => <List.Item>{u?.username || "-"}</List.Item>}
              split={false}
            />
          </div>
        );
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                background: "#0D2E4D",
                color: "#fff",
                borderRadius: "12px",
                padding: "2px 10px",
                fontWeight: 500,
                fontSize: "13px",
              }}
            >
              {record.owner?.username || "-"}
            </span>
            {sharedToList.length > 0 && (
              <Popover content={content} trigger="click" placement="bottom">
                <Button
                  type="text"
                  icon={<PlusOutlined />}
                  shape="circle"
                  size="small"
                  style={{ color: "#D97A07", marginLeft: "4px" }}
                />
              </Popover>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "10%",
      render: (status) => (
        <Tag color={getStatusColor(status)}>{status || "Unknown"}</Tag>
      ),
      sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
    },
  ];

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
